import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgClipboard = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M8.25 10.7583H15.75"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.25 13.8833H15.75"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.25 17.0083H15.75"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.125 5.75833H18.25C18.5815 5.75833 18.8995 5.89003 19.1339 6.12445C19.3683 6.35887 19.5 6.67681 19.5 7.00833V20.1333C19.5 20.4649 19.3683 20.7828 19.1339 21.0172C18.8995 21.2516 18.5815 21.3833 18.25 21.3833H5.75C5.41848 21.3833 5.10054 21.2516 4.86612 21.0172C4.6317 20.7828 4.5 20.4649 4.5 20.1333V7.00833C4.5 6.67681 4.6317 6.35887 4.86612 6.12445C5.10054 5.89003 5.41848 5.75833 5.75 5.75833H8.875C8.875 4.92953 9.20424 4.13467 9.79029 3.54862C10.3763 2.96257 11.1712 2.63333 12 2.63333C12.8288 2.63333 13.6237 2.96257 14.2097 3.54862C14.7958 4.13467 15.125 4.92953 15.125 5.75833V5.75833Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 5.13333C12.0618 5.13333 12.1222 5.15166 12.1736 5.186C12.225 5.22033 12.2651 5.26914 12.2887 5.32624C12.3124 5.38334 12.3186 5.44618 12.3065 5.5068C12.2944 5.56742 12.2647 5.6231 12.221 5.6668C12.1773 5.71051 12.1216 5.74027 12.061 5.75233C12.0003 5.76438 11.9375 5.7582 11.8804 5.73454C11.8233 5.71089 11.7745 5.67084 11.7402 5.61945C11.7058 5.56806 11.6875 5.50764 11.6875 5.44583C11.6875 5.36295 11.7204 5.28347 11.779 5.22486C11.8376 5.16626 11.9171 5.13333 12 5.13333"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgClipboard.displayName = 'SvgClipboard';
export default SvgClipboard;
